import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = ["checked"];
const _hoisted_2 = ["innerHTML"];
export default /*@__PURE__*/ _defineComponent({
    __name: 'TermsAndConditions',
    props: {
        modelValue: { type: Boolean },
        submitted: { type: Boolean }
    },
    emits: ['update:modelValue'],
    setup(__props) {
        function checked(event) {
            let target = event.target;
            return target.checked;
        }
        return (_ctx, _cache) => {
            return (_ctx.$te('terms.accept'))
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(["terms", { 'terms--invalid': __props.submitted && !__props.modelValue }])
                }, [
                    _createElementVNode("input", {
                        type: "checkbox",
                        class: "terms__input",
                        checked: __props.modelValue,
                        onChange: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('update:modelValue', checked($event)))),
                        required: ""
                    }, null, 40, _hoisted_1),
                    _cache[1] || (_cache[1] = _createTextVNode()),
                    _createElementVNode("span", {
                        class: "terms__text has-links",
                        innerHTML: _ctx.$t('terms.accept', { gtc_url: _ctx.$t('gtc.url'), privacy_url: _ctx.$t('privacy.url') })
                    }, null, 8, _hoisted_2)
                ], 2))
                : _createCommentVNode("", true);
        };
    }
});
